import { Dispatch } from 'react';
import { PostDispatch } from '../types';
import { SuSyApi } from '../../api/susyApi';
import {
    SET_PROFILE_IMAGE,
    SET_PROFILE_IMAGE_PENDING,
    UPLOAD_PROFILE_PICTURE,
} from './types';
import {
    GeneralAppSettingsAction,
    GeneralAppSettingsType,
} from '../actionTypes/settings/generalAppSettings';
import { store } from '../store';

export const savePersonalPicture =
    (profilePicture: File | null) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const formData = new FormData();

        if (profilePicture) {
            formData.append('profilePicture', profilePicture);
        }

        const responseUpload = await SuSyApi.put(
            `/user/upload/profilePicture`,
            formData
        );
        const imageId = responseUpload.data;

        const responseDownload = await SuSyApi.get(
            `/images/get/profilePicture/${imageId}`,
            { responseType: 'blob' }
        );

        const profileImage = {
            imageId: imageId,
            imageLink: URL.createObjectURL(responseDownload.data),
        };

        dispatch({
            type: UPLOAD_PROFILE_PICTURE,
            payload: profileImage,
        });
    };
export const getProfileImage =
    (imageId: string) => async (dispatch: Dispatch<PostDispatch>) => {
        const imageState = store.getState().images;

        if (imageId in imageState) {
            return;
        }

        dispatch({
            type: SET_PROFILE_IMAGE_PENDING,
            payload: { imageId },
        });

        const response = await SuSyApi.get(
            `/images/get/profilePicture/${imageId}`,
            { responseType: 'blob' }
        );

        const profileImage = {
            imageId: imageId,
            imageLink: URL.createObjectURL(response.data),
        };
        dispatch({
            type: SET_PROFILE_IMAGE,
            payload: profileImage,
        });
    };

export const getLogoImage =
    (imageId: string) =>
    async (dispatch: Dispatch<GeneralAppSettingsAction>) => {
        const response = await SuSyApi.get(`/images/get/logo/${imageId}`, {
            responseType: 'blob',
        });

        const logoURL = URL.createObjectURL(response.data);
        dispatch({
            type: GeneralAppSettingsType.GET_LOGO_IMAGE_URL,
            payload: logoURL,
        });
    };
